import Enumerator from '../global/Enumerator';

export const contactNextOfKinRelationships = [
  'none',
  'father',
  'mother',
  'brother',
  'sister',
  'son',
  'daughter',
  'cousin',
  'friend',
  'mother_in_law',
  'father_in_law',
  'brother_in_law',
  'sister_in_law',
  'uncle',
  'aunt',
  'boyfriend',
  'girlfriend',
  'spouse',
  'grandmother',
  'grandfather'
];

export class ContactNextOfKinRelationship extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'mother';
        break;
      case '2':
        correctOption = 'mother_in_law';
        break;
      case '3':
        correctOption = 'father';
        break;
      case '4':
        correctOption = 'father_in_law';
        break;
      case '5':
        correctOption = 'brother';
        break;
      case '6':
        correctOption = 'brother_in_law';
        break;
      case '7':
        correctOption = 'sister';
        break;
      case '8':
        correctOption = 'sister_in_law';
        break;
      case '9':
        correctOption = 'cousin';
        break;
      case '10':
        correctOption = 'daughter';
        break;
      case '11':
        correctOption = 'son';
        break;
      case '12':
        correctOption = 'uncle';
        break;
      case '13':
        correctOption = 'aunt';
        break;
      case '14':
        correctOption = 'friend';
        break;
      case '15':
        correctOption = 'boyfriend';
        break;
      case '16':
        correctOption = 'girlfriend';
        break;
      case '17':
        correctOption = 'spouse';
        break;
      case '18':
        correctOption = 'grandmother';
        break;
      case '19':
        correctOption = 'grandfather';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactNextOfKinRelationship.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  father: {
    get title() {
      return 'Father';
    }
  },
  mother: {
    get title() {
      return 'Mother';
    }
  },
  brother: {
    get title() {
      return 'Brother';
    }
  },
  sister: {
    get title() {
      return 'Sister';
    }
  },
  son: {
    get title() {
      return 'Son';
    }
  },
  daughter: {
    get title() {
      return 'Daughter';
    }
  },
  cousin: {
    get title() {
      return 'Cousin';
    }
  },
  friend: {
    get title() {
      return 'Friend';
    }
  },
  mother_in_law: {
    get title() {
      return 'Mother-in-law';
    }
  },
  father_in_law: {
    get title() {
      return 'Father-in-law';
    }
  },
  brother_in_law: {
    get title() {
      return 'Brother-in-law';
    }
  },
  sister_in_law: {
    get title() {
      return 'Sister-in-law';
    }
  },
  uncle: {
    get title() {
      return 'Uncle';
    }
  },
  aunt: {
    get title() {
      return 'Aunt';
    }
  },
  boyfriend: {
    get title() {
      return 'Boyfriend';
    }
  },
  girlfriend: {
    get title() {
      return 'Girlfriend';
    }
  },
  spouse: {
    get title() {
      return 'Spouse';
    }
  },
  grandmother: {
    get title() {
      return 'Grandmother';
    }
  },
  grandfather: {
    get title() {
      return 'Grandfather';
    }
  }
});

export default {
  contactNextOfKinRelationships,
  ContactNextOfKinRelationship
};
